<template>
  <div>
    <p class="display-1">{{book.name}}</p>
    <v-layout class="px-2">
      <v-flex class="border mr-2" md6>
        <div class="d-flex align-center">
          <images-picker
            class="flex-grow-1 mr-4"
            :book="book"
            accept="image/png, image/jpeg, image/bmp"
            placeholder="Chọn ảnh"
            prepend-icon="mdi-camera"
            multiple
            label="Upload Ảnh"
          ></images-picker>
        </div>
        <lingallery v-if="book.imgs" :items="items" :height="320" :id.sync="currentId" />
        <p v-else>Chưa có ảnh</p>
      </v-flex>
      <v-flex class="border mr-2" md3>
        <v-layout class="px-2">
          <p class="headline">Thông tin</p>
          <v-spacer class="grow" />
          <v-btn color="success" class="ma-2" depressed small @click.stop="save">Lưu</v-btn>
        </v-layout>
        <p class="title"></p>
        <book-new-form v-if="book" :book="book" ref="infoForm" />
      </v-flex>
      <v-flex class="border" md3>
        <v-layout class="px-2">
          <p class="headline">Mượn & Trả</p>
          <v-spacer class="grow" />
          <v-btn color="success" class="ma-2" depressed small @click.stop="save">Lưu</v-btn>
        </v-layout>
        <p class="title"></p>
        <book-assign-form :book="book" ref="asignForm" />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import BookNewForm from '@/components/basic/form/BookForm.vue'
import BookAssignForm from '@/components/basic/form/BookAssignForm.vue'
import ImagesPicker from '@/components/basic/picker/FacilityImagesPicker.vue'
import Lingallery from 'lingallery'

export default {
  components: { BookNewForm, BookAssignForm, Lingallery, ImagesPicker },
  data () {
    return {
      loading: false,
      currentId: null
    }
  },
  computed: {
    ...mapGetters('book', ['book', 'imgs']),
    ...mapState('constant', ['bookStatus', 'bookTypes']),
    ...mapGetters('app', ['department']),
    items () {
      if (!this.imgs) {
        return [
          {
            src: '/cover-default.jpg',
            thumbnail: '/cover-default.jpg',
            id: '123123'
          }
        ]
      }
      return this.imgs.map(i => ({
        src: i.url,
        thumbnail: i.url,
        id: i.id
      }))
    },
    allBookStatus () {
      return this.bookStatus.reduce(
        (data, curent) => ({
          ...data,
          [curent.status]: curent['title']
        }),
        {}
      )
    },
    allBookType () {
      return this.bookTypes.reduce(
        (data, curent) => ({
          ...data,
          [curent.status]: curent['title']
        }),
        {}
      )
    }
  },
  methods: {
    ...mapActions('book', [
      'fetchBook',
      'updateBook',
      'destroyImage'
    ]),
    async save () {
      const info = this.$refs.infoForm.getData()
      const asign = this.$refs.asignForm.getData()
      await this.updateBook({
        id: this.book.id,
        ...info,
        ...asign
      })
    },
    removeImage () {
      if (this.currentId) this.destroyImage(this.currentId)
    }
  },
  async created () {
    this.loading = true
    await this.fetchBook(this.$route.params.id)
    this.loading = false
  },
  filters: {},
  watch: {
    currentId (id) {
    }
  }
}
</script>
<style scoped>
.border {
  border: solid 1px lightgray;
}
</style>
